import React, { memo } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules';

import 'swiper/scss';
import 'swiper/css/bundle';

const SingleSlideSwiper = ({ data, className, clickable = false, navigation = true }) => {
  return (
    <Swiper
    key={data.length}
      slidesPerView={1}
      observer={true}
      observeParents={true}
      spaceBetween={0}
      loop={true}
      centeredSlides={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: clickable,
      }}
      navigation={navigation}
      modules={[Autoplay, Pagination, Navigation, EffectFade]}
      effect='fade'
      className={className}
    >
      {data.map((item, index) => {
        const isImageOnly = item.imageUrl;
        const { eventType, date, time } = item.subtitle || {};
        const hasSubtitle = eventType || date || time; 
        return (
          <SwiperSlide key={index} className="carousel-slide">
            {isImageOnly ? (
              <img
                loading="eager"
                src={item.imageUrl}
                alt={`slide-${index}`}
                className="img-cover w-100 h-100"
              />
            ) : (
              <>
                <img
                  loading="eager"
                  src={item.imgSrc}
                  alt={`slide-${index}`}
                  className="img-cover w-100 h-100"
                />
                <div className="carousel-slide-content text-center text-white">
                  <h1 className="m-0 playfair-74-medium-i carousel-title text-ellipsis" 
                    style={{ fontSize: 'clamp(2rem, 6vw, 4.625rem)'}}>{item.title}</h1>
                  {hasSubtitle && (
                  <p className="manrope-22-medium text-upper mt-24 mb-75 carousel-time">
                    {item.subtitle.eventType} <span className="mx-20">|</span> {item.subtitle.date}{' '}
                    <span className="mx-20">|</span> {item.subtitle.time}
                  </p>
                  )}
                </div>
              </>
            )}
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default memo(SingleSlideSwiper);
